// extracted by mini-css-extract-plugin
export default {"viewOptionsMenuContainer":"menu-module__viewOptionsMenuContainer--YKG3f","viewOptionsMenuOverlay":"menu-module__viewOptionsMenuOverlay--zkRnw"};